<div class="month-selector" *ngIf="{month: (month$ | async)} as streams$">
  <div class="month-selector__header">
    <button
      (click)="prev()"
      class="month-selector__control"
      [innerHTML]="getPrevIcon()"
      aria-label="previous month"
    >
      Prev
    </button>
    <span class="month-selector__output">{{streams$.month}}</span>
    <button
      (click)="next()"
      class="month-selector__control"
      [innerHTML]="getNextIcon()"
      aria-label="next month"
    >
      Next
    </button>
  </div>
  <div class="month-selector__body">
    <ng-content></ng-content>
  </div>
</div>
